import styles from "./StatusBadge.module.css";

/**
 * Status pill.
 *
 * Accessibility rule (PRD §41): status is never communicated by colour
 * alone. Every badge renders an icon *and* a text label.
 */
const TONE_CLASS = {
  live: styles.live,
  upcoming: styles.upcoming,
  final: styles.final,
  info: styles.info,
  success: styles.success,
  warning: styles.warning,
  danger: styles.danger,
  neutral: styles.neutral,
  accent: styles.accent,
};

const DEFAULT_ICONS = {
  live: "fa-solid fa-circle-dot",
  upcoming: "fa-regular fa-clock",
  final: "fa-solid fa-flag-checkered",
  info: "fa-solid fa-circle-info",
  success: "fa-solid fa-circle-check",
  warning: "fa-solid fa-triangle-exclamation",
  danger: "fa-solid fa-circle-exclamation",
  neutral: "fa-solid fa-tag",
  accent: "fa-solid fa-football",
};

const StatusBadge = ({
  tone = "neutral",
  icon,
  children,
  pulse = false,
  className = "",
  title,
}) => {
  const toneClass = TONE_CLASS[tone] ?? styles.neutral;
  const iconClass = icon ?? DEFAULT_ICONS[tone] ?? DEFAULT_ICONS.neutral;

  return (
    <span
      className={`${styles.StatusBadge} ${toneClass} ${className}`.trim()}
      title={title}
    >
      <i
        className={`${iconClass} ${pulse ? styles.pulse : ""}`.trim()}
        aria-hidden="true"
      />
      <span>{children}</span>
    </span>
  );
};

export default StatusBadge;
